import { Component } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-toolkit-list',
  templateUrl: './toolkit-list.component.html',
  styleUrls: ['./toolkit-list.component.css'],
})
export class ToolkitListComponent {
  url: string = '';
  urlTwo: string = 'download/legalFiles';

  data: Array<any> = [];

  searchText = '';
  filteredData: Array<any> = [];
  sugerenciasBusqueda: string[] = [];
  currentPage: number = 1;
  morePages: boolean = true;
  itemsPerPage: number = 15;
  step = 1;
  stepUser = 1;
  apiUrl = environment.apiUrl;

  resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fas fa-users',
      bgClass: 'bg-white',
      desc: 'Staff',
      //route: null,
      route: '/humanResources',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-city',
      bgClass: 'bg-white',
      desc: 'Toolkit',
      route: '/humanResources/toolkit',
    },
  ];

  constructor(
    private dataService: DataService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    //this.getData();
  }

  /* getData(): void {
    this.dataService.getData(this.url).subscribe((response) => {
      console.log('personnel', response);
      this.data = response.data;
      this.filteredData = [...this.data];
      //this.getStats();
      //this.getResumenEstados();
      this.actualizarSugerencias();
    });
  }
 */

  /* getData(): void {
    this.dataService
      .getDataTwo(this.url, '', '', this.currentPage, this.itemsPerPage)
      .subscribe((response) => {
        console.log('response en accounting', response);

        if (response) {
          this.data = response.data;
          this.morePages = response.data.length === this.itemsPerPage;
          //this.filteredData = [...this.data];

          this.filteredData = this.data.map((item: any) => {
            const key = this.frequencyMap[item.frequency];
          
            const formattedSalary = (value: any) =>
              value ;
            const displaySalary = formattedSalary(item.value);

            //daily: key === 'daily' ? item.value + ' ('+ item.dueDate +')' : '',
            return {
              ...item, // conserva todos los campos originales
              week: key === 'week' ? formattedSalary('WEEKLY') : '',
              biweek: key === 'biweek' ? formattedSalary('BIWEEKLY') : '',
              yearly: key === 'yearly' ? formattedSalary('YEARLY') : '',
              displaySalary: displaySalary,
            };
          });
          //console.log('filteredData', this.filteredData);
          this.actualizarSugerencias();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  } */

  getData(): void {
    this.dataService
      .getDataTwo(this.url, '', '', this.currentPage, this.itemsPerPage)
      .subscribe((response) => {
        console.log('response en human', response);

        if (response) {
          this.data = response.data;
          this.morePages = response.data.length === this.itemsPerPage;

          this.filteredData = this.data;

          this.actualizarSugerencias();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  deleteData(id: string): void {
    if (!confirm('Desea eliminar el registro?')) {
      return;
    }

    this.dataService
      .deleteData(`${this.url}/delete/${id}`)
      .subscribe((response) => {
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }

        this.getData();
      });
  }

  filterInfo() {
    const texto = this.searchText.trim().toLowerCase();
    //console.log('texto',texto);
    if (!texto) {
      this.filteredData = [...this.data];
    } else {
      this.filteredData = this.data.filter((item) => {
        return (
          (item.firstname && item.firstname.toLowerCase().includes(texto)) ||
          (item.lastname && item.lastname.toLowerCase().includes(texto))
          //(item.phone && item.phone.toLowerCase().includes(texto)) ||
          //(item.role &&
          //  item.role.name &&
          //  item.role.name.toLowerCase().includes(texto)) ||
          //(item.rol_user && item.rol_user.toLowerCase().includes(texto)) ||
          //(item.state && item.state.toLowerCase().includes(texto)) ||
          //(item.city && item.city.toLowerCase().includes(texto))
        );
      });
      //console.log('filteredData',this.filteredData);
    }
    this.getStatsFiltrado();
    this.getResumenEstadosFiltrado();
  }

  getStatsFiltrado() {
    /* this.totalConductores = this.filteredData.length;
    this.totalActivos = this.filteredData.filter((d) => d.status).length;
    this.totalInactivos = this.filteredData.filter((d) => !d.status).length;
    this.ultimoRegistro = this.filteredData.length
      ? this.filteredData[this.filteredData.length - 1].firstname +
        ' ' +
        this.filteredData[this.filteredData.length - 1].lastname
      : '-'; */
  }

  getResumenEstadosFiltrado() {
    /* this.totalNumber = this.filteredData.length;
    this.byCities = new Set(this.filteredData.map((d) => d.city)).size;
    this.active = this.filteredData.filter((d) => d.status === 'active').length;
    this.busy = this.filteredData.filter((d) => d.status === 'busy').length;
    this.pending = this.filteredData.filter(
      (d) => d.status === 'pending'
    ).length;
    this.sanctioned = this.filteredData.filter(
      (d) => d.status === 'sanctioned'
    ).length;

    this.resumenCards[0].value = this.totalConductores;
    this.resumenCards[1].value = this.byCities;
    this.resumenCards[2].value = this.totalActivos;
    this.resumenCards[3].value = this.busy;
    this.resumenCards[4].value = this.totalInactivos;
    this.resumenCards[5].value = this.sanctioned; */
  }

  actualizarSugerencias() {
    const sugerenciasSet = new Set<string>();
    this.data.forEach((item) => {
      if (item.description) sugerenciasSet.add(item.description);
      //if (item.lastname) sugerenciasSet.add(item.lastname);
      //if (item.phone) sugerenciasSet.add(item.phone);
      //if (item.role && item.role.name) sugerenciasSet.add(item.role.name);
      //if (item.rol_user) sugerenciasSet.add(item.rol_user);
      //if (item.state) sugerenciasSet.add(item.state);
      //if (item.city) sugerenciasSet.add(item.city);
    });
    this.sugerenciasBusqueda = Array.from(sugerenciasSet).filter(Boolean);
  }

  changeStep(step: number) {
    this.step = step;
  }

  changeStepUser(step: number) {
    this.stepUser = step;
  }

  get ndaEsp(): string {
    const img = 'NDA_ESPANOL.pdf';

    return img ? `${this.apiUrl}/uploads/cyb/inHouse/${img}` : '';
  }

  get ndaEng(): string {
    const img = 'NDA_ENGLISH.pdf';

    return img ? `${this.apiUrl}/uploads/cyb/inHouse/${img}` : '';
  }

  get teamAccess(): string {
    const img = 'Team_Access_Security.pdf';

    return img ? `${this.apiUrl}/uploads/cyb/inHouse/${img}` : '';
  }

  get downloadVisitorFiles(): string {
    return `${this.apiUrl}/download/visitor`;
  }

  get downloadInHouseFiles(): string {
    return `${this.apiUrl}/download/inHouse`;
  }

  /* download(): void {
    this.http
      .get(`${this.apiUrl}/download/legalFiles`, { responseType: 'blob' })
      .subscribe((file) => {
        const url = window.URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'legal_files.zip';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      });
  } */
}
